import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { describeErrorLocalized } from './errorMessages';

/** The one place a component turns a thrown value into text for the reader. */
export function useDescribeError(): (error: unknown) => string {
  const { t } = useTranslation();

  return useCallback((error: unknown) => describeErrorLocalized(error, t), [t]);
}
